import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renderSettingsResourceLabel } from "../../../../../../../utils/helpers/settings";
import { firstToUpper } from "../../../../../../../utils/helpers/string";
import { NewValue } from "../../../../../helpers/historyHelpers/components/NewValue";
import { OldValue } from "../../../../../helpers/historyHelpers/components/OldValue";
import { Label } from "../../../../../helpers/historyHelpers/components/Label";

export const renderItem = (value, label, t) => {
    const newValue = value?.new;
    const oldValue = value?.old;

    let content;

    if (typeof newValue === "boolean" || typeof oldValue === "boolean") {
        content = (
            <>
                {oldValue && <OldValue value={oldValue ? t("active") : t("not-active")} />}
                
                <NewValue value={newValue ? t("active") : t("not-active")} />
            </>
        );
    } else if (Array.isArray(newValue) && (newValue?.length > 0 || oldValue?.length > 0)) {
        const newValueFormatted = newValue.length > 0 && (
            <div className="d-flex flex-column justify-content-start align-items-start">
                {newValue.map((item, i) => {
                    return (
                        <div key={i}>
                            <span className="pr-2">
                                {firstToUpper(t("after"))}: {item?.after}
                            </span>
                            <span>
                                {t("amount")}: {item?.amount}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
        const oldValueFormatted = (
            <div className="d-flex flex-column justify-content-start align-items-start">
                {oldValue.map((item, i) => {
                    return (
                        <div key={i}>
                            <span className="pr-2">
                                {firstToUpper(t("after"))}: {item?.after}
                            </span>
                            <span>
                                {t("amount")}: {item?.amount}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
        content = (
            <>
                {oldValue.length > 0 && <OldValue value={oldValueFormatted} />}

                <NewValue value={newValueFormatted} />
            </>
        );
    } else if (typeof newValue === "string") {
        content = (
            <>
                {label === "color" ? (
                    <>
                        <span
                            style={{
                                width: "55px",
                                height: "15px",
                                borderRadius: "4px",
                                backgroundColor: oldValue,
                            }}
                        />
                        <FontAwesomeIcon className="text-muted" icon={faArrowRight} />
                        <span
                            style={{
                                width: "55px",
                                height: "15px",
                                borderRadius: "4px",
                                backgroundColor: newValue,
                            }}
                        />
                    </>
                ) : (
                    <>
                        {oldValue && <OldValue value={oldValue} />}

                        <NewValue value={newValue} />
                    </>
                )}
            </>
        );
    } else if (typeof newValue === "number" || typeof oldValue === "number") {
        content = (
            <>
                {typeof oldValue === "number" && <OldValue value={oldValue} />}

                <NewValue value={newValue} />
            </>
        );
    } else {
        content = (
            <>
                {oldValue && <OldValue value={renderSettingsResourceLabel(oldValue)} />}

                <NewValue value={renderSettingsResourceLabel(newValue)} />
            </>
        );
    }

    return (
        <div className="d-flex align-items-center gap-2 mb-1 w-100">
            <Label value={t(label)} />
            {content}
        </div>
    );
};
